<template>
  <transition @enter="enter" @leave="leave" appear>
    <div
      class="game__footer"
      v-if="game.showProgress"
      :key="game.showProgress"
    >
      <GameCounter />
      <GameNextButton />
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import anime from '@/assets/libs/anime';
import { inApp } from '@/scripts/utils';

import GameCounter from '@/components/GameCounter.vue';
import GameNextButton from '@/components/GameNextButton.vue';

export default {
  name: 'GameControls',

  components: {
    GameCounter,
    GameNextButton,
  },

  computed: {
    ...mapState({
      game: 'currentGame',
    }),
  },

  methods: {
    enter(el, done) {
      anime({
        targets: el,
        translateY: ['100%', 0],
        easing: 'cubicBezier(.5,0,0,1)',
        duration: inApp() ? 1000 : 1800,
        complete: done,
      });
    },
    leave(el, done) {
      anime({
        targets: el,
        translateY: [0, '100%'],
        easing: 'cubicBezier(.5,0,0,1)',
        duration: inApp() ? 1000 : 1800,
        complete: done,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.game__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(var(--unit-vh) - 1px);

  display: flex;
  align-items: stretch;
  justify-content: space-between;

  @include mq(ipadP) {
    width: calc(var(--unit-vw) * 10);
    padding: 0 calc(var(--unit-vw) + 1px);
  }
}
</style>
